import {InputStyles} from '../text/theme';

export const CurrencyInput = ({theme}) => {
  return {
    ...InputStyles({theme}),
  };
};
